import makeApi from '@/common/API';

const api = makeApi(() => window.env.IAM.EXTERNAL.API_URL);

export default api;
